// @flow

import * as React from 'react';
import type {UnmountHandler, ComponentMeta} from "../common/CommonTypes";
import { Collapse, CardBody, Card } from 'reactstrap';
import ReactAI from 'react-appinsights';


type Props = {
    extraClassFormGroup?: string,
    htmlName: string,
    labelText: string,
    value: number,
    min?: number,
    max?: number,
    step?: number,
    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,
    meta: ComponentMeta,
    disabled?: boolean,
    helpHtml?: string,
    phaseNr?: number,
};

type HelpState = {
    showHelp: boolean
}

class NumberInput extends React.Component<Props, HelpState> {

    constructor(props: Props) {
        super(props);
        this.state = { showHelp: false };
    }

    toggleHelp() {
        this.setState({ showHelp: !this.state.showHelp });
    }

    componentWillUnmount() {
        this.props.onUnmount(this.props.htmlName);
    }

    render() {
        const props = this.props;

        let formGroupClass = "form-group";
        if (typeof props.extraClassFormGroup !== 'undefined')
            formGroupClass += (' ' + props.extraClassFormGroup);

        let inputClass = "form-control";
        
        let errorMessage;
        if (typeof props.meta !== 'undefined' && props.meta.touched) {
            if (props.meta.valid) {
                inputClass += (' is-valid');
            }
            else {
                inputClass += (' is-invalid');
                errorMessage = props.meta.errorMessage;
            }
        }

        let upDownClass = this.state.showHelp ? "fa-angle-up" : "fa-angle-down";

        let labelSuffixPhase = this.props.phaseNr ? `-phase${this.props.phaseNr}` : '';

        const val = props.value !== -1 ?  props.value : '';
        
        return (
            <div className={formGroupClass}>
                <div className="label-with-info clearfix">
                    <label id={props.htmlName + 'Lbl' + labelSuffixPhase} htmlFor={props.htmlName}
                           className="col-form-label">{props.labelText}</label>
                    {props.helpHtml && <div className="help-symbols" onClick={this.toggleHelp.bind(this)}>
                        <span>i</span>
                    </div>}
                </div>
                <Collapse isOpen={this.state.showHelp}>
                    <Card>
                        <CardBody>
                            <span dangerouslySetInnerHTML={{__html: props.helpHtml}}/>
                        </CardBody>
                    </Card>
                </Collapse>
                <input id={props.htmlName} type="number" name={props.htmlName} value={val}
                       onChange={props.onChange} onBlur={props.onBlur} className={inputClass}
                       min={props.min} max={props.max} step={props.step} disabled={this.props.disabled === true} />
                {errorMessage && <div className="invalid-feedback">{errorMessage}</div>}
            </div>
        );
    };
}

export default ReactAI.withTracking(NumberInput);




// WEBPACK FOOTER //
// ./src/components/NumberInput.js